import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AssetPipe } from '../../../pipes/asset.pipe';

@Component({
    selector: 'app-platform-link-copied-confirmation',
    templateUrl: './platform-link-copied-confirmation.component.html',
    styleUrls: ['./platform-link-copied-confirmation.component.scss'],
    standalone: true,
    imports: [
        AssetPipe
    ]
})
export class PlatformLinkCopiedConfirmationComponent implements OnChanges {

    @Input() platform: {
        platformName: string;
        logoURL: string;
        heading: string;
        description: string;
    };
    pasteIcon: string;

    ngOnChanges(changes: SimpleChanges): void {
        this.setPasteIcon();
    }

    private setPasteIcon(): void {

        if (this.platform.platformName.toLocaleLowerCase().includes('team')) {
            this.pasteIcon = 'sharing/icon-paste-to-teams.png';
        }

        if (this.platform.platformName.toLocaleLowerCase().includes('eduvidual')) {
            this.pasteIcon = 'sharing/icon-paste-to-moodle.png';
        }
    }

}
